module.exports = __webpack_public_path__ + "static/media/ace1.8f59b7c4.png";